import { MessageResponse } from "@/generated-api";
import TimeReadStatus from "./TimeReadStatus";
import { useTranslation } from "@/hooks/useTranslation";

export default function HiddenChatBubble({
  counterpartyId,
  message,
}: {
  counterpartyId: string;
  message: MessageResponse;
}) {
  const counterparty = message.sender_id === counterpartyId;
  const t = useTranslation();

  return (
    <div className="bg-zinc-700 text-zinc-300 px-3 py-2 rounded-3xl inline-flex items-center select-none">
      <div className="relative">
        <p className="text-base break-words whitespace-pre-wrap max-w-xs lg:max-w-md">
          {t.MESSAGES.LABELS.HIDDEN}
          <span
            className={`inline-block ${
              counterparty
                ? "w-[2.4rem]"
                : message.read_at
                ? "w-[3.7rem]"
                : "w-[3.4rem]"
            }`}
          ></span>
        </p>
        <TimeReadStatus
          message={message}
          counterparty={counterparty}
          textColor="text-zinc-400"
        />
      </div>
    </div>
  );
}
